import React, { useContext, useState } from 'react';
import { Pressable, Text } from 'react-native';

import AuthContext from 'app/src/contexts/AuthContext';
import { SubNavContainer, LinkContainer, LinkSpace } from 'app/src/elements';
import Modal from 'app/src/elements/Modal';

import NewAccountGroup from './new';

const SubNav = ({ refetch }) => {
  const { hasPolicy } = useContext(AuthContext);
  const [showAddModal, setShowAddModal] = useState(false);

  return (
    <SubNavContainer>
      <LinkContainer>
        {hasPolicy({ type: 'AccountGroup', action: 'create' }) && (
          <>
            <Pressable onPress={() => setShowAddModal(true)} >
              <Text>+ Add Account Group</Text>
            </Pressable>
            <LinkSpace />
          </>
        )}
      </LinkContainer>

      {showAddModal &&
        <Modal
          showModal
          setShowModal={setShowAddModal}
          modalType="Add Account Group"
        >
          <NewAccountGroup
            setShowModal={setShowAddModal}
            refetch={refetch}
          />
        </Modal>
      }
    </SubNavContainer>
  );
};

export default SubNav;
